<template>
  <div class="w-100 px-3 my-2">
    <div class="d-flex flex-column justify-content-center align-items-start">
      <p class="mb-0 text-left text-truncate w-100">Name: <strong>{{firstName}} {{lastName}}</strong></p>
      <p class="mb-0 text-left text-truncate w-100">Email: <strong>{{email}}</strong></p>
      <p class="mb-0 text-left text-truncate w-100">Mobile: <strong>{{telephoneMobile}}</strong></p>
      <p v-if="addressString" class="mb-0 text-left text-truncate w-100">Address: <strong>{{addressString}}</strong></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { AddressHelper } from '@/helpers/AddressHelper'

export default {
  name: 'SummaryClientDetails',
  computed: {
    ...mapState('BookingUpload', [
      'firstName',
      'lastName',
      'email',
      'telephoneMobile',
      'clientAddress'
    ]),
    addressString () {
      return AddressHelper.getAddressLines(this.clientAddress).join(', ')
    }
  }
}
</script>
